import Box from '@mui/material/Box';
import { useState } from 'react';
import HeaderComponent from '../../components/common/headerComponent';
import KnowledgeBaseLayout from "../../components/layout/whistleblower/knowledgeBaseLayout";
import KnowledgeBase from "../whistleblower/knowledgeBase";

const KnowledgeBasePage = () => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <Box display='flex' flexDirection='column' height='100%'>
      <HeaderComponent
        setSidebarOpen={setMobileSidebarOpen}
        isSidebarOpen={mobileSidebarOpen}
      />
      <KnowledgeBaseLayout
        isSideBarOpen={mobileSidebarOpen}
        center={<KnowledgeBase />}
      />
    </Box>
  );
};

export default KnowledgeBasePage;